import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import {
    downloadDocumentMedia,
    openDocumentMediaInBrowser,
} from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';

const MediaDownload = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const isDownload = searchParams.get('download') === '1';
    const { t } = useTranslation();
    const startedRef = useRef(false);
    const [status, setStatus] = useState('loading');
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        if (!id || startedRef.current) {
            return;
        }

        startedRef.current = true;

        if (isDownload) {
            downloadDocumentMedia(id)
                .then(() => setStatus('success'))
                .catch((err) => {
                    setStatus('error');
                    setErrorMessage(err?.message || t('Unable to download file.'));
                });
            return;
        }

        openDocumentMediaInBrowser(id).catch((err) => {
            setStatus('error');
            setErrorMessage(err?.message || t('Unable to open file.'));
        });
    }, [id, isDownload, t]);

    if (status === 'loading') {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, p: 4 }}>
                <CircularProgress />
                <Typography>
                    {isDownload ? t('Download in progress...') : t('Loading document')}
                </Typography>
            </Box>
        );
    }

    if (status === 'error') {
        return (
            <Box sx={{ p: 4 }}>
                <Typography color="danger">{errorMessage}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 4 }}>
            <Typography>{t('Download started. You can close this page.')}</Typography>
        </Box>
    );
};

export default MediaDownload;
